import Alert from '@material-ui/lab/Alert'
import { ButtonSubmit } from './Button'
import React from 'react'
import { useStyles } from '../pages/styled'
import { specialTheme } from '../theme'
import { useClaimant } from '../context/col'
import CircularProgress from '@material-ui/core/CircularProgress'
import { ButtonProps, Grid } from '@mui/material'
import { FormikProps } from 'formik'
import { useGa4Context } from '../context/Ga4Context'
import useGa4 from '../hooks/useGa4'
import { BackButton } from './BackButton'

type SubmitSectionProps = ButtonProps & {
  pending?: boolean
  formik?: FormikProps<any> | null
  backLinkText?: string
  onBackLinkClick?: () => void
}

const ErrorSubmitBack = ({
  pending, formik, children, name, onSubmit, backLinkText, onBackLinkClick, ...rest }: SubmitSectionProps) => {
  const classes = useStyles()
  const { state } = useClaimant()
  const { ga4_formFieldError } = useGa4()

  const ga4Data = useGa4Context().ga4Data
  function handleClick(e: any) {
    if (formik == null) return
    formik.validateForm(formik.values).then((errors) => {
      objectToArray(errors).forEach((attr) => {
        ga4_formFieldError(
          {
            case_type: ga4Data?.case_type,
            step: ga4Data?.step,
            form_name: ga4Data?.form_name,
            field_name: attr.path,
            error_message: attr.value,
          }

        )
      })
    })
  }
  return (
    <React.Fragment>
      {(Boolean(state.error)) && (
        <Grid item xs={12} sm={12} xl={12} className={classes.gridButton} marginTop={'2rem'}>
          <Alert severity="error" className={classes.error} >
            {state.error}
          </Alert>
        </Grid>
      )}
      <Grid item xs={12} sm={12} xl={12} className={classes.gridButton} marginTop={'2rem'}>
        <ButtonSubmit onClick={handleClick} >
          {pending ? (
            <div color={specialTheme.colors.darkRed}>
              <CircularProgress
                color="inherit"
                size="1.5rem"
              />
            </div>
          ) : (
            children
          )}
        </ButtonSubmit>
      </Grid>
      {onBackLinkClick != null && backLinkText != null && (
        <Grid item xs={12} sm={12} xl={12} className={classes.gridCenter} marginTop={'0.8rem'}>
          <BackButton onClick={onBackLinkClick}>{backLinkText}</BackButton>
        </Grid>
      )}
    </React.Fragment>
  )
}

/**
 * Resursive object destructuring
 * @param anyObject 
 * @param partialPath Only for resursive calling
 * @returns Array of anyObject attributes
 */
function objectToArray(anyObject: any, partialPath?: string): Array<{ path: string, value: any }> {
  const _currentPath = (partialPath ?? '')
  let _objectToArray: Array<{ path: string, value: any }> = []
  Object
    .entries(anyObject)
    .forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((innerObj, index) => {
          const _inner = objectToArray(innerObj, _currentPath + key + '[' + index + '].')
          //console.log('_inner:', _inner)
          _objectToArray = _objectToArray.concat(_inner)
        })
      } else
        if (typeof value === 'object') {
          //console.log('parsing ', key)
          const _inner = objectToArray(value, _currentPath + key + '.')
          //console.log('_inner:', _inner)
          _objectToArray = _objectToArray.concat(_inner)
        }

        else {
          //console.log('pushing ', key)
          _objectToArray.push({ path: _currentPath + key, value: value })
        }
      //console.log('_objectToArray: ', _objectToArray)
    })
  return _objectToArray
}

export default ErrorSubmitBack
